
import Upload from '@/components/shared/Upload.vue'
import CodeQr from "@/components/views/invitations/CodeQr.vue";


export default [
  // {path: '/', component: Upload, name: 'root'},
  {path: '/', component: CodeQr, name: 'root'},
]
